import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

export interface SimilarInfluencersButtonProps extends ButtonProps {
  isActive?: boolean;
}

export const SimilarInfluencersButton = ({ isActive, className, ...restProps }: SimilarInfluencersButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      title={t('Similar Influencers')}
      className={cn(styles.toggleButton(isActive), className)}
      {...restProps}
    />
  );
};

const styles = {
  toggleButton: (isActive?: boolean) =>
    cn('mt-1.5 h-5 w-34 overflow-hidden text-xs font-medium break-all text-ellipsis', {
      'text-lg-active border-base-active': isActive
    })
};
